<template>
  <div class="columns is-multiline">
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <FormBrand v-model="element.brand"/>
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <FormModel v-model="element.model"/>
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Matricola" v-model="element.registration" />
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Superficie mq" v-model="element.surface" />
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Potenza kw" v-model="element.power" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    element: Object
  }
}
</script>